'use strict';

var _ = require('lodash');
var DemandAndPaxTransformerFactory = function DemandAndPaxTransformerFactory(DataTransformer, momentService, $filter, idService, configurationService, classIndicesService, FcrService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function DemandAndPaxTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'rom-analysis-demand-pax-mode';
  }
  DemandAndPaxTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  DemandAndPaxTransformerFactory.constructor = DemandAndPaxTransformerFactory;
  DemandAndPaxTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  DemandAndPaxTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  DemandAndPaxTransformerFactory.prototype.isCacheable = function () {
    return true;
  };
  DemandAndPaxTransformerFactory.prototype.transform = function (data) {
    var dataset = data.domain.serviceClassSPOSOptList;
    var result = [];
    var record, element;
    var rtpRanges = configurationService.getParsedRTPS();
    var memoizedMomentOfDepartureDate = _.memoize(momentService.of);
    var fcrKey = getFCRTagForDataRange(dataset);
    var memoizedClassesIndices = _.memoize(function (market) {
      return classIndicesService.prepareClassIndices(market + '-' + fcrKey);
    });
    for (var i = 0, length = dataset.length; i < length; i++) {
      record = {};
      element = dataset[i];
      record.origin = element.origin;
      record.destination = element.destination;
      record.departureDate = element.departureDate;
      record.departureDateMoment = memoizedMomentOfDepartureDate(element.departureDate, momentService.FIELD.DEPARTURE_DATE);
      record.dow = rmMomentFormat(record.departureDateMoment, 'DAY_OF_WEEK').toUpperCase();
      record.service = idService.parseServiceId(element.serviceId);
      record["class"] = element.className;
      record.classIndex = memoizedClassesIndices(element.origin + '-' + element.destination)[element.className];
      record.departureTime = element.departureTime;
      record.departureTimeMoment = memoizedMomentOfDepartureDate(element.departureTime, momentService.FIELD.DEPARTURE_TIME, 'HHmm');
      record.actPax = element.actualMetrics.sale;
      record.optPax = element.maxRevMetrics.sale;
      record.demand = element.demandFC;
      record.romTimeBucket = element.romTimeBucket - 1;
      record.fare = element.fare;
      record.netContribution = element.maxRevMetrics.netContribution;
      record.bookType = element.resHoldType;
      record.daysToDeparture = rtpRanges[element.romTimeBucket - 1];
      record.cabin = element.cabin;
      record.actSpill = element.actualMetrics.spill;
      record.actRecap = element.actualMetrics.recap;
      record.maxSpill = element.maxRevMetrics.spill;
      record.maxRecap = element.maxRevMetrics.recap;
      record.flowType = element.flowType;
      record.spos = element.spos;
      record.isNonStop = element.isNonStop;
      record.optGroupWeeks = element.optGroupWeeks;
      record.isCodeShare = element.isCodeShare;
      result.push(record);
    }
    return result;
  };
  function getFCRTagForDataRange(data) {
    var selectedDays = _.uniq(_.map(data, function (row) {
      return momentService.of(row.departureDate + 'T' + row.departureTime, momentService.FIELD.DEPARTURE_DATE);
    }));
    return FcrService.getFcrTagForMultipleEntities([_.min(selectedDays), _.max(selectedDays)]);
  }
  return DemandAndPaxTransformerFactory;
};
DemandAndPaxTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', '$filter', 'IdService', 'ConfigurationService', 'ClassIndicesService', 'FcrService'];
module.exports = DemandAndPaxTransformerFactory;